/**
* Created By: Jennifer Mancilla
* Creation Date: 08/09/2022
* PBI: 78280 - Estructura Cotizador Arrendamiento Bepensa
*
* Last Modifier: Jennifer Mancilla
* Last Modification: 08/09/2022
*
* Feat: 78282
*
* version: 1.0.0
* copyright: 2022 INDUSTRIAS RESSER S.A DE C.V
*/

import React from 'react';
import { useState, useEffect } from 'react';
import { 
    Row, 
    Col, 
    Space,
    Button 
} from 'antd';
// Styles
import { fullHeight } from '../styles/CommonStyles';
import { 
    bestPlanTxt, 
    informationContainer, 
    logoImg, 
    quoteBttn, 
    responsiceQuoteBttn,
    responsiveLogoImg, 
    responsiveSpaceContainer, 
    spaceContainer, 
    welcomeImage 
} from '../styles/WelcomeStyles';
import { nexBttn, contentTxt } from "../styles/StepsStyles";
// Assets & others
import Logo from '../assets/whiteLogoSvg.svg';
import { Fonts } from '../utils/constants';
import { useAppSelector, useAppDispatch } from '../hooks/storeHooks';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { NumericInput } from '../components/Inputs/Inputs';
import { blockedPostalCodes } from '../constants/blockedPostalCodes';
import { getUserCP, getAvalCP } from '../reducer/slices/DataCotizador';
import styles from '../styles/Step.style';
import { Grid} from '@mui/material';
import { setUnipadHash } from '../reducer/slices/DataCotizador';
import { useSearchParams } from 'react-router-dom';
    const useStyle = styles;

export const WelcomeView = () => {
    const dataCotizador = useAppSelector(state => state.DataCotizador);
    const dispatch = useAppDispatch();
    const { width } = useAppSelector(state => state.dimensions);
    const navigate = useNavigate();
    const [isPostalCodeValid, setIsPostalCodeValid] = useState(false);
    const [showInvalidCPView, setShowInvalidCPView] = useState(false);
    const [searchParams] = useSearchParams();

    const onClickWelcome = async () => {
    const hash = dataCotizador.unipadHash || '';
        navigate(
            hash ? `/quote?id=${hash}` : "/quote",
            { state: { fromHome: true } }
        );
    };

    useEffect(() => {
        const hash = searchParams.get("id") || "";

        dispatch(setUnipadHash(hash));
    }, [searchParams]);

    const ValidateCP = (value: string) => {
        dispatch(getUserCP(value));
        dispatch(getAvalCP(value));

        if (value.length !== 5) {
            setIsPostalCodeValid(false);
            setShowInvalidCPView(false);
            return;
        }

        if (blockedPostalCodes.has(value)) {
            setIsPostalCodeValid(false);
            setShowInvalidCPView(true);
            return;
        }
        setShowInvalidCPView(false);
        setIsPostalCodeValid(true);
    };

    if (showInvalidCPView) {
        return (
            <Row style={fullHeight}>
                <Col xs={24} md={24} style={informationContainer}>
                    <Space direction="vertical" style={{...spaceContainer, ...contentTxt, textAlign: "center", maxWidth: 500 }}>
                        <img src={Logo} alt='Logo' style={width > 700 ? logoImg : responsiveLogoImg} />
                        <p style={bestPlanTxt} >
                            Gracias por tu interés en cotizar con nosotros
                        </p>

                        <p >
                            Actualmente no contamos con cobertura en tu zona,
                            por lo que no es posible generar una cotización.
                        </p>
                        <p >
                            Esperamos tener la oportunidad de ofrecerte 
                            nuestros productos más adelante
                        </p>

                        <Button
                            shape="round"
                            style={{...nexBttn,
                            textAlign: "center"}}
                            onClick={() => setShowInvalidCPView(false)}
                        >
                            Volver al inicio
                        </Button>
                    </Space>
                </Col>
            </Row>
        );
    }
    return (
        <Row style={fullHeight}>
            {/* Image */}
            {
                width > 700 &&
                    <Col span={10} style={welcomeImage}></Col>
            }

            {/* Information */}
            <Col xs={24} md={14} style={informationContainer}>
                <Space 
                    direction='vertical' 
                    style={width > 700 ? spaceContainer : responsiveSpaceContainer}
                    className="WelcomeContainer">
                    <img src={Logo} alt='Logo' style={width > 700 ? logoImg : responsiveLogoImg} />

                    <p style={bestPlanTxt}>
                        Estrena HOY Y SIEMPRE <br />
                        <span style={{ fontFamily: Fonts.sspLight  }}>Cotiza en 60 segundos</span>
                    </p>
                    <Grid  container spacing={2} style={{paddingBottom:30}}>
                        <Grid item xs={12}>
                            <p style={{fontFamily:Fonts.sspBold, fontSize:20, color:'white'}}>Ingresa tu Código Postal para iniciar tu cotización</p>
                        </Grid>
                        <Grid item xs={12} md={6} >
                            <NumericInput
                                label="CP"
                                onChange={ValidateCP}
                                isOnlyNumber
                                maxlength={5}
                                value={dataCotizador.userCP}
                            />
                        </Grid>
                    </Grid>
                    <div style={{ marginTop: 10 }}>
                        <Button
                        shape="round"
                        style={{     ...nexBttn,
                            opacity: isPostalCodeValid ? 1 : 0.5,
                            cursor: isPostalCodeValid ? "pointer" : "not-allowed"
                        }}
                        onClick={onClickWelcome}
                        disabled={!isPostalCodeValid}
                        >
                        Cotizar ahora
                        </Button>
                     </div>
                </Space>
            </Col>
        </Row>
    );
}

